import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  resolveButton: {
    color: theme.palette.green_200.main,
    '&:hover': {
      backgroundColor: theme.palette.green_50.main
    }
  },

  actionButtonsContainer: {
    display: 'flex'
  },
  actionButtonIcons: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&:hover': {
      color: theme.palette.blue_300.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.blue_50.main
    },
    [theme.breakpoints.down('sm')]: {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main
    }
  },
  actionButtonNewTicketIcon: {
    backgroundColor: theme.palette.green_200.main,
    padding: 6,
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main
    }
  },
  actionButtonDeleteIcons: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_300.main,
    '&:hover': {
      color: theme.palette.red_100.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.blue_50.main
    }
  },
  actionButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    [theme.breakpoints.down('sm')]: {
      background:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.blue_100.main
    }
  },
  pendingButtonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  ticketAcceptButton: {
    cursor: 'pointer',
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_400.main,
      boxShadow: 'none'
    }
  },

  formControl: {
    minWidth: 200,
    marginRight: 8
  },
  queueSelect: {
    '& .MuiOutlinedInput-root': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main,
      '& fieldset': {
        borderColor:
          theme.palette.type === 'dark'
            ? theme.palette.dark_300.main
            : theme.palette.gray_100.main
      },
      '&:hover fieldset': {
        borderColor: theme.palette.blue_300.main
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.palette.blue_300.main
      }
    }
  },
  menu: {
    '& .MuiMenuItem-root': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.gray_400.main
    }
  }
}))
